export const PaymentMethod = {
    CASH: 'cash',
    CREDIT_CARD: 'credit_card',
};
export const Currency = {
    USD: 'USD',
};
export const LoginStatus = {
    SUCCESS: 'success',
    FAILURE: 'failure',
};
export const LoginMethod = {
    EMAIL: 'email',
    SSO: 'sso',
};

export const Page = {
    STOCK_ORDER: 'Stock Order',
    LOGIN: 'login',
    HOME: 'home',
    PLP: 'plp',
    PDP: 'PDP',
    PDP_BUY_NOW: 'PDP Buy Now',
    QUOTE: 'quote',
    DIRECT: 'direct',
    PLP_RELATED_PRODUCTS: 'plp_related_products',
    PDP_RELATED_PRODUCTS: 'pdp_related_products',
    HEADER: 'header',
    FOOTER: 'footer',
};
export const YES = 'yes';
export const NO = 'no';

export const LaborFrom = {
    VEHICLE: 'vehicle',
    PART: 'part',
};

export const CTAType = {
    BANNER: 'banner',
    BUTTON: 'button',
};

export const VehicleSelectionMethod = {
    BY_TYPE: 'by type',
    BY_VIN: 'by vin',
    BY_PLATE: 'by plate',
    RECENT_VEHICLES: 'recent vehicles',
};

export const VehicleSelectionFrom = {
    QUOTE: 'Quote',
    LANDING_PAGE: 'Landing Page',
    CATALOG_LOOKUP: 'Catalog Lookup',
    PLP: 'PLP',
    PDP: 'PDP',
    OTHER: 'Other',
};

export const VehicleSpecsFrom = {
    VEHICLE_SELECTOR: 'Vehicle Selector', // User clicked the “Vehicle Data/Specs” link on the Vehicle Selector
    PLP_VEHICLE_DATA_SPECS: 'PLP Vehicle Data/Specs', // User clicked the “Vehicle Data/Specs” link on the Part Type PLP header
    PLP_EXHAUST_DIAGRAMS: 'PLP Exhaust Diagrams', // User clicked the “Exhaust Diagrams” link on the Part Type PLP header for exhaust related part types
    PLP_APPLICATION_DOCUMENTS: 'PLP Application Documents', // User clicked the Application Document icon on the Part Type PLP
    PDP_APPLICATION_DOCUMENTS: 'PDP Application Documents', // User clicked the Application Document icon on the PDP
};

export const FilterType = {
    BRAND: 'brand',
};
